import {
  createStart,
  createCsrfMiddleware,
  createMiddleware,
} from "@tanstack/react-start";

import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
import { renderErrorPage } from "@/engine/support/error-page";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // Lovable's own routes authenticate themselves and must reach their handler
  // untouched by anything the app wraps around a request.
  if (new URL(request.url).pathname.startsWith("/lovable/")) return next();
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware, csrfMiddleware],
  // Registered where `auth-attacher.ts` says it has to be: without it the
  // browser attaches no bearer token to a server function, and the middleware
  // that reads one would refuse every call. Nothing calls a server function
  // yet — there is no `createServerFn` in the application — so this is the
  // half that cannot be added later by whoever writes the first one.
  functionMiddleware: [attachSupabaseAuth],
}));
